import {
  DepositForfeiturePolicy,
  DepositStatus,
  type IDepositMetadata,
} from '@principle-theorem/principle-core/interfaces';
import { toTimestamp } from '@principle-theorem/shared';

/** Owns policy evaluation and state changes for deposit forfeiture. */
export class DepositForfeiture {
  /** Exposes whether a policy permits automatic forfeiture to its processors. */
  static evaluatePolicy(forfeiturePolicy: DepositForfeiturePolicy): {
    autoForfeit: boolean;
  } {
    return { autoForfeit: forfeiturePolicy === DepositForfeiturePolicy.Auto };
  }

  /** Produces the metadata change only when a paid deposit may be auto-forfeited. */
  static forfeit(
    depositMetadata: IDepositMetadata,
    forfeiturePolicy: DepositForfeiturePolicy
  ): { shouldForfeit: boolean; updatedMetadata?: Partial<IDepositMetadata> } {
    // Only forfeit if deposit is in 'Paid' status
    if (depositMetadata.status !== DepositStatus.Paid) {
      return { shouldForfeit: false };
    }

    const { autoForfeit } = DepositForfeiture.evaluatePolicy(forfeiturePolicy);

    if (!autoForfeit) {
      // Manual policy — flag but don't process
      return { shouldForfeit: false };
    }

    // Auto-forfeit — update status
    return {
      shouldForfeit: true,
      updatedMetadata: {
        status: DepositStatus.Forfeited,
        forfeitedAt: toTimestamp(),
      },
    };
  }
}
